var _symbol, _symbol2, _rect, _use, _use2, _use3, _use4, _use5, _use6, _use7, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "card",
    face: "TH",
    width: "10em",
    preserveAspectRatio: "none",
    viewBox: "-120 -168 240 336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "SHT",
    viewBox: "-600 -600 1200 1200",
    preserveAspectRatio: "xMinYMid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -300C0 -400 100 -500 200 -500C300 -500 400 -400 400 -250C400 0 0 400 0 500C0 400 -400 0 -400 -250C-400 -400 -300 -500 -200 -500C-100 -500 0 -400 -0 -300Z",
    fill: "red"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "VHT",
    viewBox: "-500 -500 1000 1000",
    preserveAspectRatio: "xMinYMid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-260 430L-260 -430M-50 0L-50 -310A150 150 0 0 1 250 -310L250 310A150 150 0 0 1 -50 310Z",
    stroke: "red",
    strokeWidth: 80,
    strokeLinecap: "square",
    strokeMiterlimit: 1.5,
    fill: "none"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 335,
    x: -119.5,
    y: -167.5,
    rx: 12,
    ry: 12,
    fill: "white",
    stroke: "black"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#VHT",
    height: 32,
    x: -114.4,
    y: -156
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 26.769,
    x: -111.784,
    y: -119
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 70,
    x: -87.501,
    y: -135.501
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 70,
    x: 17.501,
    y: -135.501
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 70,
    x: -87.501,
    y: -68.5
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 70,
    x: 17.501,
    y: -68.5
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 70,
    x: -35,
    y: -102
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#VHT",
    height: 32,
    x: -114.4,
    y: -156
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 26.769,
    x: -111.784,
    y: -119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 70,
    x: -87.501,
    y: -135.501
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 70,
    x: 17.501,
    y: -135.501
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 70,
    x: -87.501,
    y: -68.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 70,
    x: 17.501,
    y: -68.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SHT",
    height: 70,
    x: -35,
    y: -102
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/th.b0081ae0.svg";
export { ForwardRef as ReactComponent };